<template>
  <div class="c-certificate">
    <img id="img" :src="src" alt="" :width="width" :height="height">
  </div>
</template>

<script>
import { Certificate } from '@/libs/canvas'

export default {
  props: {
    name: {
      type: String,
      default: '张三丰'
    },
    content: {
      type: String,
      default: '于2019年04月29日之06月03日参加“从技术原理到深度学习”学院课程，经考核成绩合格，特发此证。'
    },
    time: {
      type: String,
      default: '2018年10月29日'
    },
    code: {
      type: String,
      default: '3084590'
    },
    width: {
      type: [Number, String],
      default: 300
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    type: {
      type: String,
      default: 'online'
    },
    teachers: {
      type: [String, Array]
    },
    item: Object,
  },
  data () {
    return {
      src: null
    }
  },
  methods: {
    createCert () {
      const img = document.createElement('img')
      img.crossOrigin = 'Anonymous'
      const canvas = document.createElement('canvas')
      canvas.width = 850
      canvas.height = 600

      if (this.type === 'outline') {
        img.src = "/images/certificate_outline.jpg"
      } else {
        img.src = "/images/certificate.jpg"
      }

      img.onload = () => {
        new Certificate({
          el: canvas,
          img: img
        }).createCertificate({
          name: this.name,
          content: this.content,
          time: this.time,
          code: this.code,
          type: this.type,
          teachers: this.teachers
        })

        const dataSrc = canvas.toDataURL('image/jpeg')

        this.src = dataSrc

        this.$emit('updateSrc', this.item, dataSrc)
      }
    }
  },
  mounted () {
    this.createCert()
  },
  watch: {
    code () {
      this.createCert()
    }
  }
}
</script>
